import { useQueryParamHelper } from '@shared/core/queryString';

/**
 * Event ID can be provided through various entrypoints:
 *   - as part of the url search string
 *   - stored in local storage
 */
export const useEventIdFromContext = () => {
  const { getValueString } = useQueryParamHelper();
  const eventIdFromLocation = getValueString('eventId');

  return eventIdFromLocation;
};
